import {NgModule}                   from '@angular/core';
import {CommonModule}               from '@angular/common';
import {ApDynComponentModule}       from '../../ap-dyncomponent/ap-dyncomponent.module';
import {ApStatisticsModule}         from '../../statistics/ap-statistics.module';
import {ApResponsiveTextModule}     from '../../ap-responsive-text/ap-responsive-text.module';
import {ApCoreModule}               from '../../ap-core/ap-core.module';
import {ButtonModule}               from '@progress/kendo-angular-buttons';
import {PpPlanningWizardComponent}  from './planning-wizard/pp-planning-wizard.component';
import {PpPlanShowComponent}        from './pp-plan-show.component';
import {PpPlanBookingComponent}     from './pp-plan-booking.component';
import {PpPlanBookingShowComponent} from './pp-plan-booking-show.component';
import {PpLogfileEditComponent}     from './pp-logfile-edit.component';
import {PpProductWizardComponent}   from './pp-product-wizard/pp-product-wizard.component';
import {
  DetailsCommonUiProvider
}                                   from './planning-wizard/configs/ui-providers/details.common.ui-provider';
import {
  DetailsTargetRateUiProvider
}                                   from './planning-wizard/configs/ui-providers/details.target-rate.ui-provider';
import {
  DetailsTargetRateMapPerPlanUiProvider
}                                   from './planning-wizard/configs/ui-providers/details.target-rate-map-per-plan.ui-provider';
import {
  DetailsTargetRateMapPerFieldUiProvider
}                                   from './planning-wizard/configs/ui-providers/details.target-rate-map-per-field.ui-provider';
import {
  DetailsUniformUiProvider
}                                   from './planning-wizard/configs/ui-providers/details.uniform.ui-provider';
import {
  OverviewGridColumnsUiProvider
}                                   from './planning-wizard/configs/ui-providers/overview.grid-columns.ui-provider';
import {
  SelectionGridColumnsUiProvider
}                                   from './planning-wizard/configs/ui-providers/selection.grid-columns.ui-provider';
import {
  PpProductWizardDetailsUiProvider
}                                   from './pp-product-wizard/configs/pp-product-wizard-details.ui-provider';
import {ApTranslationModule}        from '../../translation/ap-translation.module';
import {ApSingleClickDirective}     from '../../ap-utils/directives/ap-single-click.directive';

@NgModule({
  declarations: [
    PpLogfileEditComponent,
    PpPlanningWizardComponent,
    PpPlanShowComponent,
    PpPlanBookingComponent,
    PpPlanBookingShowComponent,
    PpProductWizardComponent
  ],
  imports: [
    CommonModule,
    ApDynComponentModule,
    ApStatisticsModule,
    ApResponsiveTextModule,
    ApCoreModule,
    ButtonModule,
    ApTranslationModule,
    ApSingleClickDirective
  ],
  providers: [
    PpProductWizardDetailsUiProvider,
    SelectionGridColumnsUiProvider,
    DetailsCommonUiProvider,
    DetailsUniformUiProvider,
    DetailsTargetRateUiProvider,
    DetailsTargetRateMapPerFieldUiProvider,
    DetailsTargetRateMapPerPlanUiProvider,
    OverviewGridColumnsUiProvider
  ]
})
export class PpEntryComponentsModule {
}
